import { render } from "./JobUI.vue?vue&type=template&id=c55f1102"
import script from "./JobUI.vue?vue&type=script&lang=js"
export * from "./JobUI.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__